export enum SocialAccountEndpoints {
    SocialAccounts = '/social-accounts'
}
